import { render, staticRenderFns } from "./PrjMembers.vue?vue&type=template&id=7445a1d3&"
import script from "./PrjMembers.vue?vue&type=script&lang=ts&"
export * from "./PrjMembers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports